<template>
  <div id="cat">
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row mb-6">
          <div class="vx-col w-full mb-2">
            <vs-button @click="createAccount()" class="bg_l_green">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
              {{ $t("CreateDepartmans") }}
            </vs-button>
          </div>
        </div>

        <Create-departman
          :show="modifyPopup"
          :model="modalModel"
          @finish="onfinish"
          @close="closeModifyPopup"
        >
        </Create-departman>
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('Departman'), sort: 'Departman' },
                { title: $t('CreateOn'), sort: 'CreateOn' },
                { title: $t('Action') },
              ]"
            >
              <template slot-scope="{ row }">
                <td>
                  {{ row.name }}
                </td>
                <td>
                  {{ row.persianCreateOn ? row.persianCreateOn : "-" }}
                </td>

                <td>
                  <vs-button
                    radius
                    color="success"
                    size="small"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-edit"
                    @click.prevent="editAccount(row)"
                    class="ml-4 d-inline"
                  ></vs-button>
                  <vs-button
                    radius
                    color="danger"
                    size="small"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-x"
                    @click.prevent="deleteAccount(row.id)"
                    class="ml-4 d-inline"
                  ></vs-button>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DataGrid from "@/components/datagrid/DataGrid";
import CreateDepartman from "./CreateDepartman.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    DataGrid,
    CreateDepartman,
  },
  data() {
    return {
      modifyPopup: false,
      modalModel: {},
      gridDataSource: {
        type: "app",
        service: "Procurements/api/DepartmentsQuery/by-paging",
      },
      gridSearchData: {},
    };
  },
  methods: {
    ...mapActions({
      deleteDepartman: "departman/deleteDepartman",
    }),
    createAccount() {
      this.modalModel = {};
      this.modifyPopup = true;
    },
    editAccount(model) {
      this.modalModel = { id: model.id, name: model.name };
      this.modifyPopup = true;
    },
    deleteAccount(model) {
      this.$swal({
        position: "center-center",
        text: "آیا از حذف این آیتم اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if(result.value){
          this.deleteDepartman( model).then(() => {
          this.$refs.grid.renderGrid();

          this.$swal({
            position: "center-center",
            type: "success",
            text: "آیتم با موفقیت حذف شد",
            showConfirmButton: false,
            timer: 2000,
          });
        });
        }

      });
    },
    closeModifyPopup() {
      this.modifyPopup = false;
    },
    onfinish() {
      this.closeModifyPopup();
      this.$refs.grid.renderGrid();
    },
  },
};
</script>
